import { Card } from '@trafiflow/shared-ui';
import { Network } from 'lucide-react';

export default function OrgChart() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-[#202223]">Organization Chart</h1>
                <p className="text-sm text-[#6d7175]">Visualize your organization's hierarchy</p>
            </div>

            <Card className="p-12 flex flex-col items-center justify-center text-center space-y-4">
                <div className="w-16 h-16 rounded-full bg-primary-lighter flex items-center justify-center text-primary">
                    <Network className="w-8 h-8" />
                </div>
                <h2 className="text-xl font-semibold">Under Construction</h2>
                <p className="text-[#6d7175] max-w-sm">
                    We are building a powerful visual org chart to help you manage your team's structure.
                </p>
            </Card>
        </div>
    );
}
